import { useEffect, useState } from "react";
import "../settings.css";
import SideBar from "../Components/SideBar/SideBar";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { showSnackBar } from "../../../../../../store/common/snackBarSlice";
import { updateGeneralSettings } from "../../../../../../services/settings.services";
import { findSettingByType } from "../../../../../../helpers/helpers";
import { addUser } from "../../../../../../store/userSlice";
import { Autocomplete, TextField } from "@mui/material";
import BoltButton from "../../../../../../Components/UI/Buttons/BoltButton";
import { FiClock } from "react-icons/fi";
import moment from "moment-timezone";

const autocompleteSx = {
  "& .MuiOutlinedInput-root": {
    height: "36px",
    padding: "0 9px",
    fontSize: "14px",
    borderRadius: "8px",
    "& fieldset": { borderColor: "var(--color-ui-border)" },
    "&:hover fieldset": { borderColor: "var(--color-ui-border)" },
    "&.Mui-focused fieldset": { borderColor: "#60a5fa", borderWidth: "1px" },
  },
  "& .MuiAutocomplete-input": { padding: "0 !important" },
  "& .MuiAutocomplete-endAdornment": { right: "8px" },
  "& .MuiAutocomplete-popupIndicator": {
    color: "#9ca3af",
    "& svg": { fontSize: "18px" },
  },
};

const timeZones = moment.tz.names();

function TimeSettings() {
  const { t } = useTranslation("settings");
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [value, setValue] = useState("America/Toronto");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.general_settings?.length) {
      const s = findSettingByType(user.general_settings, "timeZone");
      if (s?.value) setValue(s.value);
    }
  }, [user]);

  const handleSave = async () => {
    if (!value) {
      dispatch(showSnackBar({ text: t("time.required"), severity: "error" }));
      return;
    }
    setLoading(true);
    const response = await updateGeneralSettings({ setting_type: "timeZone", value });
    setLoading(false);
    if (!response?.data?.success) {
      dispatch(showSnackBar({ text: t("common:messages.somethingWentWrong"), severity: "error" }));
      return;
    }
    const updatedUser = { ...user, general_settings: response.data.result };
    dispatch(addUser(updatedUser));
    localStorage.setItem("user", JSON.stringify(updatedUser));
    dispatch(showSnackBar({ text: t("common:messages.settingsUpdated"), severity: "success" }));
  };

  return (
    <div className="parent_wraper">
      <SideBar active="3_1" />
      <div className="dash_table_wrapper">
        <div className="flex items-center justify-between px-1 mb-6">
          <h2 className="text-lg font-semibold text-ui-text m-0">{t("sidebar.items.timeZone")}</h2>
        </div>

        <div className="bg-ui-surface border border-ui-border rounded-xl p-4 max-w-xs">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 rounded-lg bg-brand-light flex items-center justify-center shrink-0">
              <FiClock size={14} className="text-brand" />
            </div>
            <p className="text-sm font-semibold text-ui-text m-0">{t("sidebar.items.timeZone")}</p>
          </div>

          <div className="mb-4">
            <label className="block text-xs font-medium text-ui-text-muted mb-1.5">{t("time.select")}</label>
            <Autocomplete
              options={timeZones}
              value={value || null}
              onChange={(_, newValue) => setValue(newValue ?? "America/Toronto")}
              getOptionLabel={(o) => o || ""}
              sx={autocompleteSx}
              renderInput={(params) => <TextField {...params} placeholder={t("time.search")} />}
            />
          </div>

          <BoltButton label={t("actions.saveChanges")} variant="primary" size="md" loading={loading} onClick={handleSave} />
        </div>
      </div>
    </div>
  );
}

export default TimeSettings;
